import React, { useState } from 'react';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TR from './../../Trans';

function ErrorDialog(props) {

  const renderButtons = () => { 
    if (props.isRetryable) {
      return <Button color="success" onClick={() => window.location.reload(false)} autoFocus>
        {TR.cm_retry}
      </Button>;
    } else {
      return <Button color="success" onClick={props.onClose} autoFocus>
        OK
      </Button>;
    }
  };

  const handleKeyDown = (event) => {
if (event.key === 'Enter') { 
    }
  };

  return (
    <BDialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {props.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          {renderButtons()}
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default ErrorDialog;